import { render, staticRenderFns } from "./PopoverHeader.vue?vue&type=template&id=14944b1a&"
import script from "./PopoverHeader.vue?vue&type=script&lang=js&"
export * from "./PopoverHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports